import ResizableEditor, { CompletionContext, EditorHandle } from '@component/business-component/resizable-editor/resizable-editor';
import { defaultBorder, defaultBorderRadius, defaultInputHeight, lightGreyColor } from '@config/styledVar';
import * as React from 'react';
import { EditOutlined } from '@ant-design/icons';
import { NiModal } from '@component/ant-component';
import './index.less';

export type CodeTextAreaProps = {
  dataId?: string;
  inModal?: boolean;
  mode?: 'text' | undefined;
  disabled?: boolean;
  data: string;
  update: (next: string) => void;
  language?: string;
  placeholder?: string;
  completionContext?: CompletionContext;
};

const CodeTextArea: React.FC<CodeTextAreaProps> = ({ inModal, mode, disabled, placeholder, data, update, dataId, language, completionContext }) => {

  const [editing, setEditing] = React.useState<boolean>(false);
  const [editingText, setEditingText] = React.useState<string>(data);
  const [showingText, setShowingText] = React.useState<string>(data);

  const editingTextRef = React.useRef<string>(editingText);
  React.useEffect(() => {
    editingTextRef.current = editingText;
  }, [editingText]);

  const dataRef = React.useRef<string>(data);
  React.useEffect(() => {
    dataRef.current = data;
    setShowingText(data);
  }, [data]);

  const editorRef = React.useRef<EditorHandle>(null);

  const pUpdate = (next: string) => {
    setEditingText(next);
  };

  const pOnBlur = (e: any) => {
    setEditing(false);
    setShowingText(dataRef.current);
  };

  return <div>{
    !editing ? <div
      key="code-textarea"
      className="new-prompt"
      onClick={(e: any) => {
        if (disabled) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();

        setEditing(true);
        setEditingText(dataRef.current);

        setTimeout(() => {
          editorRef.current?.focus();
        }, 100);
      }}><span className="new-prompt-text">{showingText || <span style={{ color: lightGreyColor }}>{disabled ? 'Non Editable' : (placeholder ?? 'Click here to edit')}</span>}</span>
    </div>
      :
      <ResizableEditor
        ref={editorRef}
        dataId={dataId}
        disabled={disabled}
        initialValue={data}
        language={language || (editingText.trimStart().startsWith('{') ? 'json' : 'kotlinTemplate')}
        onChange={pUpdate}
        onBlur={pOnBlur}
        completionContext={completionContext}
        onCancel={(e) => {
          e.preventDefault();
          e.stopPropagation();
          pOnBlur(e);
        }}
        onSave={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const next = editingTextRef.current;
          setEditing(false);
          setShowingText(next);
          if (next !== dataRef.current) {
            update(next);
          }
        }}
      />
  }
  </div>;
};

export default CodeTextArea;
